/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {ImageModeId, ratioIdToRatioMap} from '../../../../types/galleryTypes';

export const promotionItemCustomCssVars = ({styleParams: styles}: CustomCssVarsFnParams) => {
  const isCrop = styles.numbers.gallery_promoCardsImageMode === ImageModeId.Crop;

  return {
    promoItemImageRatio: String(ratioIdToRatioMap[styles.numbers.galleryImageRatio]),
    promoCardsImageModeFit: isCrop ? 'cover' : 'contain',
  };
};
